
  import { mapEntityProperties } from '@/utils/mapEntityProperties'
  import { CancelMealReasonEntity } from '../../domain/entities/CancelMealReasonEntity'
  export class CancelMealReasonModel extends CancelMealReasonEntity {
  constructor(dataDto) {
    super()
    mapEntityProperties(this, dataDto)
  }
}